import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { baseUrl } from "../../redux/constants/const";
import { Button, Modal, Typography } from "antd";
import { toast } from "react-toastify";
import moment from "moment";
import logo from "../../assets/logomain.png";
import { Link, useParams } from "react-router-dom";

const ConflictEmail = () => {
  // const { addToast } = useToasts();
  const { id } = useParams();
  const [subsData, setSubsData] = useState('');
  const [subsId, setSubsId] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelledModal, setCancelledModal] = useState(false);
  const userData = useSelector(state => state?.profileReducer?.user_data);
  const staticUserId = `6729d2d325fb61b209feb81c`;

  console.log(subsData?.data?.length > 0, 'subsData')

  const getConflictedSubs = async () => {
    try {
      const res = await axios.post(`${baseUrl}user/checkUserConflictedSubscription`, {
        user_id: id,
      });
      setSubsData(res?.data);

    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelSubscription = async () => {
    try {
      const res = await axios.post(`${baseUrl}user/cancelConflictedSubs`, {
        user_id: id,
        subscription_id: subsId,
      });
      // setSubsData(res?.data);
      if (res) {
        setCancelModal(false)
        getConflictedSubs()
        toast.success(res?.data?.message, { appearance: "success", autoDismiss: true })
      }
    } catch (error) {
      toast.error(error?.message, { appearance: "error", autoDismiss: true })
    }
  }

  useEffect(() => {
    getConflictedSubs();
  }, [userData])

  return (
    <>
      <section className='login'>
        <div className="register_img_div">
          <div className='login_opt_content2'>
            {subsData?.data?.length > 0 ? subsData?.data?.map((item) => {
              const purchaseDate = item?.purchased_on?.length > 10 ? item?.purchased_on : item?.purchased_on * 1000;
              return (
                <div key={item?._id} className="annual_card mb-3" style={{ border: "2px solid #ae841e" }}>
                  <div className="">
                    <div className="d-flex align-items-center">
                      <span className="small_font">{item?.is_academy_subscription === 1 ? "Academy Subscription" : "Subscription"}</span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    {/* <Typography className="normal_font">{item?.is_academy_subscription === 1 && item?.total_students && item?.total_students}</Typography> */}
                    {!item?.stripeSubscriptionDetail?.canceled_at ?
                      <Typography className="normal_font">Date of payment: {moment(purchaseDate).format('ll')}</Typography>
                      :
                      <Typography className="normal_font">Canceled Date: {moment(item?.stripeSubscriptionDetail?.canceled_at * 1000).format('ll')}</Typography>
                    }
                    <div>
                      {!item?.stripeSubscriptionDetail?.cancel_at || !item?.stripeSubscriptionDetail?.canceled_at ?
                        <>
                          {item?.platform === "stripe" && <Button onClick={() => { setCancelModal(true); setSubsId(item?.stripe_subscription_id) }} type="text" className="common_background2 text-white rounded">cancel</Button>}
                          {item?.platform === "ios" && <Link target="_blank" to={`https://apps.apple.com/account/subscriptions`}><Button type="text" className="common_background2 text-white rounded">cancel from app store</Button></Link>}
                          {item?.platform === "android" && <Link target="_blank" to={`https://play.google.com/store/account/subscriptions?package=com.bulletproofforbjj`}><Button type="text" className="common_background2 text-white rounded">cancel from play store</Button></Link>}
                        </>
                        :
                        <Button onClick={() => setCancelledModal(true)} type="text" className="common_background2 text-white rounded">cancelled</Button>
                      }
                      {item?.platform === "stripe" ?
                        <Typography className="small_font text-end" style={{ color: "#ae841e" }}>{item?.stripeSubscriptionDetail?.plan?.currency?.toUpperCase()} {item?.stripeSubscriptionDetail?.plan?.amount?.toFixed(2) / 100}</Typography>
                        :
                        <Typography className="small_font text-end" style={{ color: "#ae841e" }}>{item?.planDetail?.currency ? item?.planDetail?.currency?.toUpperCase() : "USD"} {item?.planDetail?.amount?.toFixed(2)}</Typography>
                      }
                    </div>
                  </div>
                </div>
              )
            }) :
              <h1 className="">You don't have any conflicted Subscription</h1>
            }
          </div>
        </div>
      </section>


      <Modal
        open={cancelledModal}
        onCancel={() => setCancelledModal(false)}
        footer={null}
      >
        <div className="text-center">
          <img src={logo} alt="successGif" width={"40%"} />
          <Typography className='small_font pt-3'>Subscription Already Cancelled</Typography>
          {/* <Button onClick={() => navigate('/pricing')} className='common_btn px-3' style={{ height: "25px" }}>OK</Button> */}
        </div>
      </Modal>

      {/* Cancel Modal */}
      <Modal closable={false} open={cancelModal} onOk={handleCancelSubscription} onCancel={() => setCancelModal(false)} >
        <p className="trial_font">Are you sure you want to cancle your BJJ subscription?</p>
      </Modal>
    </>
  )
}

export default ConflictEmail;
